import React from 'react';
import { MotionImage, FadeInSection } from '../ui/MotionPrimitives';

const ContactHero: React.FC = () => {
  return (
    <FadeInSection className="w-full bg-black">
      <div className="mx-auto flex min-h-[90vh] max-w-6xl flex-col-reverse items-center gap-10 px-6 py-16 md:flex-row md:items-center md:px-10 lg:py-24">
        {/* Text column */}
        <div className="w-full text-center text-white md:w-1/2 md:text-left">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[rgb(216,133,70)]">
            Contact Us
          </p>
          <h1 className="mt-3 text-3xl font-semibold tracking-tight sm:text-4xl lg:text-5xl">
            Let&apos;s start a conversation.
          </h1>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-white/80 sm:text-base">
            Reach out to our team in Dubai or the United States for investment inquiries,
            partnerships, or tailored advisory support across our global real estate portfolio.
          </p>
        </div>

        {/* Image column */}
        <div className="flex w-full justify-center md:w-1/2">
          <MotionImage
            src="/images/section images/contact us.jpg"
            alt="Contact Hogar Dorado House"
            className="h-auto max-h-[360px] w-full max-w-md object-contain"
          />
        </div>
      </div>
    </FadeInSection>
  );
};

export default ContactHero;
